query GetImpactMeasurementCategories {
  impactMeasurementCategories {
    id
    title
    headingColour
    items {
      id
      title
      description
      example
      impactMeasurementCategoryId
      readMore
    }
  }
}
